module.exports = __webpack_public_path__ + "static/img/5.77e3c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/5.png
// module id = podQ
// module chunks = 1